import { downloadAuthorizedFile } from "../api/fileDownloadHelper";

function buildExportUrl(
  dashboardId: string,
  format: "pdf" | "xlsx",
  from: string,
  to: string,
  shareToken?: string
): string {
  const params = new URLSearchParams({ from, to });
  if (shareToken) {
    params.set("shareToken", shareToken);
  }
  return `/dashboards/${dashboardId}/export/${format}?${params.toString()}`;
}

export const dashboardExportService = {
  downloadPdf: (dashboardId: string, from: string, to: string, fileName: string, shareToken?: string) =>
    downloadAuthorizedFile(buildExportUrl(dashboardId, "pdf", from, to, shareToken), fileName),

  downloadExcel: (dashboardId: string, from: string, to: string, fileName: string, shareToken?: string) =>
    downloadAuthorizedFile(buildExportUrl(dashboardId, "xlsx", from, to, shareToken), fileName),
};
